{/* Auto-generated icon - do not edit */}
import React from 'react'

interface CloudIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const CloudIcon = React.forwardRef<SVGSVGElement, CloudIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 163 107"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M135.456 40.6913C131.664 39.5812 127.802 38.7292 123.897 38.1414C122.303 37.8654 120.661 37.5796 119.037 37.2606C117.486 19.1332 108.443 7.83583 91.4047 2.72589C87.958 1.73572 84.429 1.06625 80.8611 0.726525C60.6764 -1.44023 42.6244 8.6102 34.8905 26.3239C33.2388 30.1081 32.4865 34.2217 31.7594 38.2029C31.4574 39.8581 31.1697 41.4283 30.8256 42.9439C29.2808 43.6942 27.6822 44.4016 26.1328 45.0879C22.4729 46.7086 18.6873 48.3848 15.4097 50.7088C6.92093 56.7308 2.03892 65.754 1.30019 76.8018C0.411786 90.0952 9.973 101.29 25.0928 104.661C31.6557 106.122 38.601 106.207 45.3175 106.288L46.6906 106.305C57.0398 106.439 67.5175 106.576 78.0825 106.576C95.7081 106.576 113.578 106.197 131.46 104.799C136.382 104.371 141.156 102.88 145.456 100.429C149.756 97.9773 153.482 94.6231 156.38 90.5937C161.503 83.441 163.332 74.8418 161.397 67.0021C158.193 54.0048 149.464 45.1533 135.456 40.6913ZM150.141 77.4314C147.749 84.9853 142.527 89.9236 134.617 92.1113C131.659 92.8961 128.632 93.392 125.579 93.591C105.46 95.0661 41.2934 96.495 28.2343 94.5899C21.8282 93.6556 16.7841 90.7222 14.0314 86.3313C11.3008 81.9776 10.8698 76.3888 12.784 70.171C16.0117 59.6901 23.1624 52.9467 34.0384 50.1229C37.3944 49.2513 38.4105 47.4798 39.111 44.5158C39.3442 43.5286 39.5646 42.5297 39.7823 41.5275C40.5981 37.8014 41.4418 33.949 43.102 30.632C49.1226 18.6114 60.7924 11.6036 74.271 11.6036C75.9111 11.6048 77.5492 11.7063 79.1776 11.9075C99.8488 14.452 104.838 24.6347 110.087 39.8783C110.225 40.3624 110.302 40.8618 110.317 41.3651L110.343 41.6913C110.69 45.7801 111.928 46.9487 116.099 47.1268C128.472 47.6566 137.38 51.0533 144.132 57.8172C150.375 64.0695 152.339 70.4855 150.141 77.4314Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="162" height="107" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

CloudIcon.displayName = 'CloudIcon'
